import React from "react";
import { Routes, Route } from "react-router-dom";

import AgeAssessmentLayout from "./components/layout/AgeAssessmentLayout";
import Dashboard from "./pages/dashboard/Dashboard";
import AgeAssessmentCases from "./pages/cases/AgeAssessmentCases";
import OurPartners from "./pages/our-partners/OurPartners";
import Tutorials from "./pages/tutorials/Tutorials";
import CaseDetails from "./pages/cases/details/CaseDetails";
import NewCaseRegistration from "./pages/cases/new-case-registration/NewCaseRegistration";
import DentalExamination from "./pages/cases/dental-examination/DentalExamination";
import AgeGroup from "./pages/cases/exam/age-group/AgeGroup";
import FAQs from "./pages/faqs/FAQs";
import PrimaryTeethStaging from "./pages/cases/exam/exam-subadults/PrimaryTeethStaging";
import PermanentTeethStaging from "./pages/cases/exam/exam-subadults/PermanentTeethStaging";
import WisdomTeethStaging from "./pages/cases/exam/exam-subadults/WisdomTeethStaging";
import RadioGraphhToothAnalysis from "./pages/cases/exam/exam-adults/RadioGraphhToothAnalysis";
import IntactToothAnalysis from "./pages/cases/exam/exam-adults/intect-tooth-analysis/IntactToothAnalysis";
import SectionedToothAnalysis from "./pages/cases/exam/exam-adults/sectioned-tooth-analysis/SectionedToothAnalysis";
import ShortPdfReport from "./pages/cases/details/child/short-pdf-report/ShortPdfReport";
import AgeAssessmentSettings from "./pages/settings/AgeAssessmentSettings";
import AgeAssessmentSupport from "./pages/support/AgeAssessmentSupport";

const AgeAssessmentRoutes = () => {
  return (
    <Routes>
      <Route element={<AgeAssessmentLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cases" element={<AgeAssessmentCases />} />
        <Route path="/cases/details" element={<CaseDetails />} />
        <Route path="/cases/details/report" element={<ShortPdfReport />} />
        <Route path="/cases/new-case" element={<NewCaseRegistration />} />
        <Route
          path="/cases/new-case/dental-examination"
          element={<DentalExamination />}
        />
        <Route path="/cases/age-group" element={<AgeGroup />} />
        <Route
          path="/cases/age-group/sub-adult/primary"
          element={<PrimaryTeethStaging />}
        />
        <Route
          path="/cases/age-group/sub-adult/permanent"
          element={<PermanentTeethStaging />}
        />
        <Route
          path="/cases/age-group/sub-adult/wisdome"
          element={<WisdomTeethStaging />}
        />
        <Route
          path="/cases/age-group/adults/radiographic-tooth-analysis"
          element={<RadioGraphhToothAnalysis />}
        />
        <Route
          path="/cases/age-group/adults/intact-tooth-analysis"
          element={<IntactToothAnalysis />}
        />
        <Route
          path="/cases/age-group/adults/sectioned-tooth-analysis"
          element={<SectionedToothAnalysis />}
        />
        <Route
          path="/cases/age-group/adults/intact-tooth-analysis"
          element={<IntactToothAnalysis />}
        />
        <Route path="/our-partners" element={<OurPartners />} />
        <Route path="/tutorial" element={<Tutorials />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/settings" element={<AgeAssessmentSettings />} />
        <Route path="/support" element={<AgeAssessmentSupport />} />
      </Route>
    </Routes>
  );
};

export default AgeAssessmentRoutes;
